import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import RequestForm from '@/components/RequestForm';

interface RequestFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialProfession?: string | null;
}

const RequestFormDialog: React.FC<RequestFormDialogProps> = ({
  open,
  onOpenChange,
  initialProfession
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>
            {t('requestForm.title')} {t('requestForm.titleHighlight')}
          </DialogTitle>
        </DialogHeader>
        <RequestForm 
          onSuccess={handleSuccess}
          initialProfession={initialProfession}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RequestFormDialog;
